<template>
  <div class="modifyPass_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon3.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">修改密码</div>
        <div class="order_subtitle"></div>
      </div>
    </div>
    <div class="content_box">
      <div class="table_content">
        <el-form :model="form" status-icon ref="ruleForm" label-width="100px">
          <el-form-item label="旧密码" prop="pass">
            <el-input
              type="password"
              v-model="form.oldPassword"
              autocomplete="off"
              class="width400"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newpass">
            <el-input
              type="password"
              v-model="form.newPassword"
              autocomplete="off"
              class="width400"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="form.againPassword"
              autocomplete="off"
              class="width400"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              class="btn_style"
              @click="submitForm"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { changePasswordApi } from "../../api/index";
export default {
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        againPassword: "",
      },
    };
  },
  created() {},

  methods: {
    submitForm() {
      if (!this.form.oldPassword) {
        this.$message.warning("请输入旧密码");
        return;
      }
      if (!this.form.newPassword) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (!this.form.againPassword) {
        this.$message.warning("请再次输入新密码");
        return;
      }
      if (this.form.newPassword !== this.form.againPassword) {
        this.$message.warning("两次输入的新密码不一致，请重新输入");
        return;
      }
      changePasswordApi({
        oldPassword: this.form.oldPassword,
        password: this.form.newPassword,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("修改密码成功,请重新登录");
          this.$store.commit("CLEAR_VUEX");
          this.$router.push({
            name: "Home",
          });
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
  },
};
</script>

<style lang="less">
.modifyPass_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
  @media screen and (min-width: 480px) {
    .width400 {
      width: 400px;
    }
    .width150 {
      width: 150px;
    }
  }
  @media only screen and (max-width: 480px) {
    .width400 {
      width: 250px;
    }
    .width150 {
      width: 150px;
    }
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>